import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DropdownInterface } from '../../../../app-components/interfaces/dropdown-interface';
import { LANGUAGES } from '../../../shared/models/languages.const';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-email-generator-form',
	templateUrl: './email-generator-form.component.html',
	styleUrls: ['./email-generator-form.component.scss']
})
export class EmailGeneratorFormComponent implements OnInit {
	@Input() public generatorForm: FormGroup = new FormGroup({});
	@Input() public optionalText = '';
	@Input() public ToneError: boolean;
	@Input() public isContext = false;
	@Input() public resettingForm: Subject<boolean> = new Subject<boolean>();
	@Input() public validate: Subject<boolean> = new Subject<boolean>();
	@Output() public validateChange: EventEmitter<boolean> = new EventEmitter();
	public selectedOutputLang = 'en';
	public selectedOutputTone: string;
	public oneTimeScroll = true;
	public maxOutputs = 3;
	public outputLang = [...LANGUAGES];

	public outputTone = [
		{ name: 'Excited', id: 1 },
		{ name: 'Friendly', id: 2 },
		{ name: 'Happy', id: 3 },
		{ name: 'Sad', id: 4 },
		{ name: 'Witty', id: 5 },
		{ name: 'Relaxed', id: 6 },
		{ name: 'Professional', id: 7 },
		{ name: 'Bold', id: 8 },
		{ name: 'Persuasive', id: 9 },
		{ name: 'Serious', id: 10 }
	];
	public maxOutputArray = [
		{ name: '3 Outputs', value: 3 },
		{ name: '2 Outputs', value: 2 },
		{ name: '1 Output', value: 1 }
	];
	@Output() public selectedOutputToneEvent = new EventEmitter<any>();
	@Output() public selectedOutputLangEvent = new EventEmitter<any>();

	constructor() {}

	ngOnInit(): void {
		this.validate.subscribe(res => {
			if (res) {
				this.checkValidation();
			}
		});
		this.resettingForm.subscribe(res => {
			if (res) {
				this.resetForm();
			}
		});
	}

	public changeToneSource(event: DropdownInterface): void {
		this.selectedOutputToneEvent.emit(event);
	}

	public changeLangSource(event): void {
		this.selectedOutputLangEvent.emit(event);
	}

	private resetForm() {
		this.removeValidators();
		this.generatorForm.reset();
	}

	private checkValidation(): void {
		this.generatorForm.setControl(
			'name',
			new FormControl(this.generatorForm.controls.name.value, {
				validators: [Validators.required, Validators.maxLength(80)]
			})
		);

		this.generatorForm.setControl(
			'context',
			new FormControl(this.generatorForm.controls.context.value, {
				validators: [Validators.required, Validators.maxLength(200)]
			})
		);

		if (!this.isContext) {
			this.generatorForm.get('context').setValidators([]);
		}

		this.generatorForm.setControl(
			'description',
			new FormControl(this.generatorForm.controls.description.value, {
				validators: [Validators.required, Validators.maxLength(400)]
			})
		);
		this.generatorForm.setControl(
			'outputTone',
			new FormControl(this.generatorForm.controls.outputTone.value, {
				validators: [Validators.required]
			})
		);
		this.generatorForm.markAllAsTouched();
		this.generatorForm.updateValueAndValidity();
		this.validateChange.emit(this.generatorForm.valid);
	}
	public removeValidators(): void {
		this.generatorForm.setControl(
			'name',
			new FormControl(this.generatorForm.controls.name.value, {
				validators: []
			})
		);

		this.generatorForm.setControl(
			'context',
			new FormControl(this.generatorForm.controls.context.value, {
				validators: []
			})
		);

		this.generatorForm.setControl(
			'description',
			new FormControl(this.generatorForm.controls.description.value, {
				validators: []
			})
		);
		this.generatorForm.setControl(
			'outputTone',
			new FormControl(this.generatorForm.controls.outputTone.value, {
				validators: []
			})
		);
	}
}
